import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-language",
  "use": "icon-language-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-language\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 96C281.6 96 96 281.6 96 512s185.6 416 416 416 416-185.6 416-416S742.4 96 512 96z m0 800c-212.8 0-384-171.2-384-384s171.2-384 384-384 384 171.2 384 384-171.2 384-384 384z m0-800c-115.2 0-208 185.6-208 416s92.8 416 208 416 208-185.6 208-416S627.2 96 512 96z m0 800c-97.6 0-176-171.2-176-384s78.4-384 176-384 176 171.2 176 384-78.4 384-176 384zM112 496h800v32H112v-32z\" p-id=\"21689\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/language.svg
// module id = +Dip
// module chunks = 68